import { useMap } from '@cobliteam/hooks';
import Icon from '@cobliteam/ui/icons';
import { useState } from 'react';
import { ControlButton } from '../ControlButton/ControlButton';
import * as styles from './styles';

const MIN_ZOOM = 3;
const MAX_ZOOM = 18;

const ZoomControl = () => {
  const { mapZoom, map } = useMap();
  const [zoom, setZoom] = useState(mapZoom);

  const handleZoomIn = () => {
    setZoom(zoom + 1);
    map.zoomIn();
  };

  const handleZoomOut = () => {
    setZoom(zoom - 1);
    map.zoomOut();
  };

  return (
    <div className={`leaflet-control ${styles.zoomControl} mt-4 space-y-0.5`}>
      <ControlButton Icon={<Icon name='plus' />} disabled={zoom === MAX_ZOOM} onClick={handleZoomIn} />
      <ControlButton Icon={<Icon name='minus' />} disabled={zoom === MIN_ZOOM} onClick={handleZoomOut} />
    </div>
  );
};

export default ZoomControl;
